export default {
    adjustments: {
        title: "Justeringar",
        reset: "Återställa",
        light: {
            title: "Ljus",
            brightness: "Ljusstyrka",
            contrast: "Kontrast",
            shadows: "Skuggor",
        },
        color: {
            title: "Färg",
            saturation: "Mättnad",
            temperature: "Temperatur",
            blacks: "Svarta",
            whites: "Vita ",
        },
        detail: {
            title: "Detalj",
            clarity: "Klarhet",
            sharpness: "Skärpa",
            blur: "Dunkel",
        },
    },
};
